module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report",
    attrs: {
      "id": "question-thread"
    }
  }, [(!_vm.isLoading) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "userCard"
  }, [(!_vm.question.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "color": "#0179d5",
      "backgroundColor": "#E9E9E8",
      "src": "static/avatar.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "src": _vm.question.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', {
    staticClass: "badges"
  }, [(_vm.question.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.question.user.profile.url
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.encodeText(_vm.question.user.display_name)) + " "), _c('country-badge', {
    attrs: {
      "alpha2": _vm.question.user.country.alpha2,
      "tooltip": _vm.question.user.country.country_name
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }, [_vm._v(_vm._s(_vm.question.user.diabetes_type))]), _vm._v(" "), _c('div', [_vm._v("Posts: " + _vm._s(_vm.question.posts))])])], 1) : _vm._e(), _vm._v(" "), (_vm.question.content) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.question.content)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', [_c('mu-flat-button', {
    attrs: {
      "icon": "history",
      "label": "See all replies"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToThread()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('h2', [_vm._v("Reported answer")]), _vm._v(" "), _c('mu-card', [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "userCard"
  }, [(!_vm.answer.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "color": "#0179d5",
      "backgroundColor": "#E9E9E8",
      "src": "static/avatar.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answer.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "src": _vm.answer.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', {
    staticClass: "badges"
  }, [(_vm.answer.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answer.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answer.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.answer.user.profile.url
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.encodeText(_vm.answer.user.display_name)) + " "), _c('country-badge', {
    attrs: {
      "alpha2": _vm.answer.user.country.alpha2,
      "tooltip": _vm.answer.user.country.country_name
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }, [_vm._v(_vm._s(_vm.answer.user.diabetes_type))]), _vm._v(" "), _c('div', [_vm._v("Posts: " + _vm._s(_vm.answer.posts))])])], 1) : _vm._e(), _vm._v(" "), (_vm.answer.answer) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.answer.answer)
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('report', {
    attrs: {
      "typeId": parseInt(_vm.$route.params.id),
      "type": "THREAD_ANSWER"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Handle report"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._v("\n            What do you want to do this with answer?\n          ")]), _vm._v(" "), _c('mu-card-text', [_c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "KEEP",
      "label": "Keep it"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1), _vm._v(" "), _c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "REMOVE",
      "label": "Remove it"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "type": "button",
      "label": "Ammend",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c6c222c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Reports/AnswerReport.vue
// module id = 3624
// module chunks = 1